import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { Form, Field } from 'react-final-form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Alert } from 'react-bootstrap';
import courts from '../../../data/courts';
import districtNosOptions from '../../../data/districtNosOptions';
import getCauses from '../../../data/causes';
import { searchDistrict, resetLocalCourtSearch } from '../../../redux/actions/localCourtSearchAction';
import { validateCivil } from './formValidation';
import CaseNumberTooltip from '../FormElements/tooltips/caseNumberTooltip/CaseNumberTooltip';
import { hasValidClientCode } from '../../../redux/actions/clientCodeAction';

import './LocalCourtSearch.less';

const regionOptions = orderBy(courts.reduce((accum, next) => {
  if (next.type === 'district') {
    accum.push({
      label: next.name.replace('District Court', '').trim(),
      value: next.code,
    });
  }
  // CITDCE is not your ordinary Civil court, search/query page is different
  // if (next.code === 'citdce') {
  //   accum.push({
  //     label: 'US International Trade',
  //     value: next.code,
  //   });
  // }
  return accum;
}, []), ['label'], ['asc']);

const onSubmit = (values, { clientCode, onSearch, isValidClientCode }) => {
  if (!isValidClientCode()) {
    return;
  }

  values.pacer_client = clientCode;
  onSearch(values);
};

export const CivilForm = props => (
  <Form
    onSubmit={values => onSubmit(values, props)}
    initialValues={{}}
    validate={validateCivil}
    render={({ handleSubmit, submitFailed, values, form, errors, error }) => (
      <form onSubmit={handleSubmit} className="local-court-form">
        <div className="form-item">
          <label>Region</label>
          <Field
            name="court_code"
            parse={({ value }) => value}
          >
            {({ input, meta }) => (
              <Select
                {...input}
                clearable={false}
                options={regionOptions}
                onChange={(e) => { values.cause_of_action = null; input.onChange(e); }}
                placeholder="Select a jurisdiction"
                className={`form-select ${meta.error && meta.submitFailed ? 'error' : ''}`}
              />
            )}
          </Field>
        </div>
        <div className="form-item">
          <label>
            Case Number
            <CaseNumberTooltip />
          </label>
          <Field
            name="case_no"
            component="input"
            type="text"
            maxLength="128"
            placeholder="Search by case number - it's free"
            className={`form-input ${submitFailed && errors && errors.case_no ? 'error' : ''}`}
          />
        </div>
        <div className="form-separator">
          <div className="form-item-group">
            <hr />
            <strong>or search by</strong>
            <hr />
          </div>
          <div className="warning">
            WARNING: If you search with the following criteria your search will not be subject to the 30-page limit
            on PACER charges; you will be billed for ALL returned pages so DO NOT use broad search criteria.
          </div>
        </div>
        <div className="form-item">
          <label>Nature of Suit</label>
          <Field name="nos">
            {({ input }) => (
              <Select
                {...input}
                multi
                options={districtNosOptions}
                className="form-select"
              />
            )}
          </Field>
        </div>
        <div className="form-item">
          <label>Cause of Action</label>
          <Field name="cause_of_action">
            {({ input }) => (
              <Select
                {...input}
                multi
                options={getCauses(values.court_code)}
                className="form-select"
              />
            )}
          </Field>
        </div>
        <div className="form-item form-item-group">
          <div>
            <label>Filed Date from</label>
            <Field name="filed_from">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
          <div>
            <label>Filed Date to</label>
            <Field name="filed_to">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
        </div>
        {/*<div className="form-item form-item-group party-name">*/}
        {/*  <div>*/}
        {/*    <label>Last / Business Name</label>*/}
        {/*    <Field*/}
        {/*      name="last_business_name"*/}
        {/*      component="input"*/}
        {/*      type="text"*/}
        {/*      maxLength="128"*/}
        {/*      className={`form-input ${submitFailed && errors && errors.last_business_name ? 'error' : ''}`}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <label>First Name</label>*/}
        {/*    <Field*/}
        {/*      name="first_name"*/}
        {/*      component="input"*/}
        {/*      type="text"*/}
        {/*      maxLength="128"*/}
        {/*      className={`form-input ${submitFailed && errors && errors.first_name ? 'error' : ''}`}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <label>Middle Name</label>*/}
        {/*    <Field*/}
        {/*      name="middle_name"*/}
        {/*      component="input"*/}
        {/*      type="text"*/}
        {/*      maxLength="128"*/}
        {/*      className="form-input"*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}

        <div className="action-btn-container">
          <button type="submit" className="form-submit green action-btn-search">
            Search
          </button>
          <button
            type="button"
            className="form-submit"
            onClick={() => { form.reset(); props.onClickSearchReset(); }}
          >
            Clear
          </button>
        </div>
        {submitFailed && error &&
          <Alert bsStyle="danger">
            <div>{error}</div>
          </Alert>
        }
      </form>
    )}
  />
);

CivilForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClickSearchReset: PropTypes.func.isRequired,
  clientCode: PropTypes.string,
};

CivilForm.defaultProps = {
  clientCode: '',
};

const mapStateToProps = state => ({
  clientCode: state.getIn(['clientCodeReducer', 'sessionClientCode']),
});

const mapDispatchToProps = {
  onSearch: searchDistrict,
  onClickSearchReset: resetLocalCourtSearch,
  isValidClientCode: hasValidClientCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(CivilForm);



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/CivilForm.jsx